/*$(document).ready(function() {
  $('.prdColorOptions').click(function(e) {
    var slValue = $(this).data('opvalue');
    var slOption = $(this).data('optclass');
    alert($(".opt_"+slOption).val());
    $("#optLabel_"+slOption+" > span").html(slValue);
    $(".opt_"+slOption).val(slValue).trigger('click');
    const varChange = new VariantSelects();
    varChange.onVariantChange();
    alert($(".opt_"+slOption).val());
  });
});*/

$('.product-form__submit').prop("disabled", true);
var swiper
var slider
$(document).ready(function() {

  $('.product-form__submit').prop("disabled", false);
  $('.header-wrapper').sticky();

  $('.mainPrdThumb').click(function(e){
    var mainSRC = $(this).data('media');
    $('.mainPrdImage').find("img").attr("src",mainSRC);
    $('.mainPrdImage').find("img").attr("srcset","");
  });

  $(".viewMoreDescription").colorbox({inline:true, maxWidth:"95%"});
  $(".viewShippingPolicy").colorbox({inline:true, maxWidth:"95%"});

  $(".vwGallery").colorbox({rel:'vwGallery', transition:"fade", maxWidth:"85%", maxWidth:"85%"});

  $(".headerHome").parents('.section-header').addClass("rspHeaderHome");

  $('#lnkFullDesc').click(function(e){
    $('#lnkFullDesc > span').html($('#lnkFullDesc > span').html() == '-' ? '+' : '-');
    $('#prdFullDesc').toggle();
  });

  $('#lnkOverview').click(function(e){
    $('#lnkOverview > span').html($('#lnkOverview > span').html() == '-' ? '+' : '-');
    $('#prdOverview').toggle();
  });

  $('.mpdThumbs').click(function(e){
    e.stopPropagation()
    var mainImage = $(this).data('image');
    const type = $(this).data('type');
    if (type == 'video') {
        $('#video_product_first').show()
        $('#mainImage_wcq').hide()
    } else {
        $('#video_product_first').hide()
        $('#mainImage_wcq').show()
        $('#mainPrdImg').attr('src', mainImage);
        $('#mainImage_wcq').find("a").attr("href",mainImage);
    }
  })

  $('#mainPrdImg').click((e) => {
    e.preventDefault()
    e.stopPropagation()
    const src = $('#mainPrdImg').parent()[0].href;
    $(".vwGallery").each((index, item) => {
        if (item.href == src) {
            item.click()
        }
    })
  })

  $('.swiper-slide').each(function() {
    $(this).find('video').css('width', '100%');
  });

  swiper = new Swiper ('.galleryThumbs', {
		slidesPerView: 'auto',
		loop: true,
		spaceBetween: 10,
		freeMode: true,
        allowSlidePrev: false,
        allowSlideNext: false,
      	watchSlidesProgress: true,
	});

  slider = new Swiper ('.gallerySlider', {
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
        thumbs: {
          swiper: swiper,
        }
	});

  $('#bcSelect').change(function(e) {
    var slSiteURL = $(this).val();
	if(slSiteURL != '/')
		window.open(slSiteURL, "_self");
  });
  
  $('#slSite').change(function(e) {
      var slSiteURL = $(this).val();
  	if(slSiteURL != '/')
  		window.open(slSiteURL);
  });

  $windowWidth = $(window).width();
   if ($windowWidth <= 991) {
    $('.ftBlockHeader').click(function (e) {
      var blockID = $(this).data('block');
      $('#block'+blockID).toggle();
      $('#ftbPlus'+blockID).toggle();
    })
   }
      
$('.prdColorOptions').click(function(e) {
    const colorKeywords = [];
  $('.prdColorOptions').each(function() {
    // 获取每个颜色选项的opvalue，并标准化（转小写+去空格）
    const colorVal = $(this).data('opvalue') || '';
    const standardColor = colorVal.toLowerCase().replace(/\s+/g, '');
    // 去重并添加到数组（避免重复值）
    if (standardColor && !colorKeywords.includes(standardColor)) {
      colorKeywords.push(standardColor);
    }
  });

  // 获取当前点击的颜色选项数据
  var slValue = $(this).data('opvalue');
  var slOption = $(this).data('optclass');
  var slImgValue = $(this).data('opimgvalue');

  // 更新颜色标签和选中状态
  $("#optLabel_"+slOption+" > span").html(slValue);
  $('.'+slOption+'_optImage').removeClass('activeOption');
  $("#optImg_"+slOption+"_"+slImgValue).addClass('activeOption');

  // 标准化当前选中的颜色值（用于匹配）
  const targetColor = slValue.toLowerCase().replace(/\s+/g, '');


  // 获取所有swiper-slide（兼容标签/类名写法）
  const swiperSlideList = document.querySelectorAll('.galleryThumbs .swiper-slide');
  
  // 2. 遍历控制每个slide的显示/隐藏
  swiperSlideList.forEach(slide => {
    const img = slide.querySelector('img');
    const imgSrc = img ? (img.src || '').toLowerCase() : '';
    
    // 判断：图片是否包含任意颜色关键词（区分通用图片/颜色专属图片）
    const isColorSpecificImg = colorKeywords.some(color => {
      return imgSrc.includes(color);
    });

    // 核心规则：
    // - 匹配当前颜色 → 显示
    // - 无任何颜色匹配（通用图）→ 显示
    // - 匹配其他颜色 → 隐藏
    if (imgSrc.includes(targetColor) || !isColorSpecificImg) {
      // 显示：恢复宽度+边距，确保可见
      slide.style.width = '52px';
      slide.style.border = '1px solid #d8d8d8';
      slide.style.margin = '4px';
      slide.style.marginRight = '4px';
    } else {
      // 隐藏：宽度0+清空边距，避免占位
      slide.style.width = '0';
      slide.style.border = '0';
      slide.style.margin = '0';
      slide.style.marginRight = '0';
    }
  });

  const swiperSlideList2 = document.querySelectorAll('.mainPrdThumbnails .mpdThumbs');
  
  // 2. 遍历控制每个slide的显示/隐藏
  swiperSlideList2.forEach(slide => {
    const img = slide.querySelector('img');
    const imgSrc = img ? (img.src || '').toLowerCase() : '';
    
    // 判断：图片是否包含任意颜色关键词（区分通用图片/颜色专属图片）
    const isColorSpecificImg = colorKeywords.some(color => {
      return imgSrc.includes(color);
    });

    // 核心规则：
    // - 匹配当前颜色 → 显示
    // - 无任何颜色匹配（通用图）→ 显示
    // - 匹配其他颜色 → 隐藏
    if (imgSrc.includes(targetColor) || !isColorSpecificImg) {
      // 显示：恢复宽度+边距，确保可见
      slide.style.width = '100px';
      slide.style.border = '1px solid #d8d8d8';
      slide.style.margin = '8px';
    } else {
      // 隐藏：宽度0+清空边距，避免占位
      slide.style.width = '0';
      slide.style.border = '0';
      slide.style.margin = '0';
    }
  });
});
const firstColorOption = $('.prdColorOptions').first();
if (firstColorOption.length) {
  firstColorOption.trigger('click');
}


  $('.cstDropID1').click(function(e) {
    e.stopPropagation();
    $(this).addClass('cstDropdownActive');    
  });
  $('.cstDropID2').click(function(e) {
    e.stopPropagation();
    $(this).addClass('cstDropdownActive');    
  });

  $(".cstDropdown input:radio").click(function(e) {
    e.stopPropagation();
    var slOption =  $(this).parent().parent().parent().data('optclass');
    var slOriginalOption =  $(this).parent().parent().parent().data('optriginalclass');
    var slValue = $("input[name='"+slOriginalOption+"']:checked").val();
    $("#optLabel_"+slOption).html(slValue);
     $(this).parent().parent().parent().removeClass('cstDropdownActive');
   });
  init3dShowPc()
  init3dShowH5()
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

   if (parentMenuElement) {
    const allOpenSubmenus = this.querySelectorAll('.menu-opening');
    allOpenSubmenus.forEach((openSubmenu, index) => {
        if (index != 0) {
          openSubmenu.removeAttribute('open');
          openSubmenu.querySelector('summary').setAttribute('aria-expanded', false);
        }
    });
  }
    
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

/**
 * HeaderMenu 自定义元素
 * 处理桌面端菜单的鼠标悬停展开/收起逻辑
 * 解决鼠标从子菜单移回父菜单时无法展开的问题
 */
class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.isDesktop = window.innerWidth > 991;
    this.hoverHandlersSetup = false;
    this.init();
  }

  /**
   * 初始化菜单事件监听
   */
  init() {
    // 监听窗口大小变化，判断是否为桌面端并重新初始化
    const handleResize = () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth > 991;
      
      // 如果从移动端切换到桌面端，需要设置悬停事件
      if (!wasDesktop && this.isDesktop && !this.hoverHandlersSetup) {
        this.setupDesktopHover();
        this.hoverHandlersSetup = true;
      }
    };

    window.addEventListener('resize', handleResize);

    // 只在桌面端启用鼠标悬停功能
    if (this.isDesktop) {
      this.setupDesktopHover();
      this.hoverHandlersSetup = true;
    }
  }

  /**
   * 设置桌面端鼠标悬停事件
   */
  setupDesktopHover() {
    // 获取所有有子菜单的菜单项
    const menuItems = this.querySelectorAll('details[id^="Details-HeaderMenu-"]');
    
    menuItems.forEach((detailsElement) => {
      const summary = detailsElement.querySelector('summary');
      const submenu = detailsElement.querySelector('ul[id^="HeaderMenu-MenuList-"]');
      
      if (!summary || !submenu) return;

      // 为每个菜单项创建独立的关闭定时器
      let closeTimeout = null;

      // 打开子菜单的辅助函数
      const openSubmenu = () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
        detailsElement.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        detailsElement.classList.add('menu-opening');
      };

      // 延迟关闭子菜单的辅助函数
      const scheduleClose = () => {
        if (closeTimeout) {
          clearTimeout(closeTimeout);
        }
        closeTimeout = setTimeout(() => {
          detailsElement.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          detailsElement.classList.remove('menu-opening');
          closeTimeout = null;
        }, 300); // 300ms 延迟，给用户时间移回菜单
      };

      // 鼠标进入父菜单项时，打开子菜单
      summary.addEventListener('mouseenter', (e) => {
        openSubmenu();
      });

      // 鼠标离开父菜单项时
      summary.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        // 如果鼠标移动到子菜单或仍在 details 元素内，不关闭
        if (relatedTarget && (submenu.contains(relatedTarget) || detailsElement.contains(relatedTarget))) {
          return;
        }
        scheduleClose();
      });

      // 鼠标进入子菜单时，确保菜单保持打开
      submenu.addEventListener('mouseenter', () => {
        openSubmenu();
      });

      // 鼠标离开子菜单时
      submenu.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        // 如果鼠标移动到父菜单项或仍在 details 元素内，不关闭
        if (relatedTarget && (summary.contains(relatedTarget) || detailsElement.contains(relatedTarget))) {
          return;
        }
        scheduleClose();
      });

      // 鼠标进入整个 details 元素时（包括从子菜单移回），打开菜单
      detailsElement.addEventListener('mouseenter', () => {
        openSubmenu();
      });

      // 鼠标离开整个 details 元素时，关闭菜单
      detailsElement.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        // 如果鼠标移动到菜单项外部，关闭菜单
        if (!relatedTarget || !detailsElement.contains(relatedTarget)) {
          scheduleClose();
        }
      });
    });
  }

}

customElements.define('header-menu', HeaderMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      // this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const src = this.currentVariant.featured_media.preview_image.src;
    const id = this.currentVariant.featured_media.id;
    $('#mainPrdImg').attr('src', src);
    $('.swiper-slide').each(function() {
      const itemId = $(this).data('media-id')
      console.log(itemId);
      
      if(id == itemId) {
        const index = $(this).data('swiper-slide-index')

      console.log(index);

        slider.slideTo((index + 1) % ($('.swiper-slide').length / 2),1000)
      }
    });     

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    //if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// 获取父容器（通过ID或类名）
const wrapper = document.getElementsByClassName('tda-customizer-app-section-wrapper')[0];
// 在父容器内查找目标h1元素
const h1Element = wrapper.querySelector('h1');
const match = window.location.pathname.match(/\/products\/([^\/?]+)/);
const productNameRegEx = match ? match[1] : null;

// 创建关闭按钮
const closeBtn = document.createElement('button');
closeBtn.innerHTML = '×'; // 使用叉号图标
closeBtn.style.cssText = `
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    border: none;
    font-size: 3em;
    cursor: pointer;
    padding: 0 5px;
    color: #666;
    z-index: 2;
`;

// 将按钮插入到 h1 的父元素中，并相对 h1 定位
h1Element.parentElement.style.position = 'relative'; // 父元素设为相对定位
h1Element.parentElement.insertBefore(closeBtn, h1Element.nextSibling);
h1Element.style.display = 'none'
closeBtn.onmouseover = () => closeBtn.style.color = '#ff4444';
closeBtn.onmouseout = () => closeBtn.style.color = '#666';
// 添加关闭功能
closeBtn.addEventListener('click', () => {
    close3dView()
});
function init3dShowPc() {
  if (!document.querySelector('.show-image-wcq-pc')) { return }
  document.querySelector('.show-image-wcq-pc').addEventListener('click', (e) => {
    e.stopPropagation( )
    e.preventDefault()
    document.querySelector('.tda-customizer-wrapper').style.display = 'block';
    document.querySelector('.tda-customizer-wrapper').style.position = 'static';
    document.querySelector('.wcq_overlay').style.display = 'block';
    document.getElementById('shopify-section-template--25512662991226__174169878636fa7b13').style.zIndex = '100';
    h1Element.innerHTML = productNameRegEx || '3d show'
  });
}

function getDeviceType() {
  const userAgent = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
  } else if (/Android/.test(userAgent)) {
      return 'Android';
  } else {
      return '其他';
  }
}
function init3dShowH5() {
  if (!document.querySelector('.show-image-wcq-h5')) { return }
  document.querySelector('.show-image-wcq-h5').addEventListener('click', (e) => {
    e.stopPropagation( )
    e.preventDefault()
    document.querySelector('.tda-customizer-wrapper').style.display = 'block';
    document.querySelector('.tda-customizer-wrapper').style.position = 'static';
    document.querySelector('.wcq_overlay').style.display = 'block';
    document.getElementById('shopify-section-template--25512662991226__174169878636fa7b13').style.zIndex = '100';
    let top = document.body.scrollTop || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `${-1 * top}px`;
    h1Element.innerHTML = productNameRegEx || '3d show'
  });
  const deviceType = getDeviceType();
  const modelView = document.querySelector('.tda-app-section-model-viewer').shadowRoot
  const arButton = modelView.querySelector('.ar-button').querySelector('a');
  const height = window.innerHeight - 30
  document.querySelector('.tda-app-section-content').style.height = height + 'px'
  // document.querySelector('.tda-customizer-controls-container').querySelector('h2').style.display = 'none'
  const wcq_timer = setInterval(() => {
    if (!document.querySelector('.tda-customizer-controls-container').querySelector('.swiper-wrapper')) { return }
    clearInterval(wcq_timer)
    let nodelist = document.querySelector('.tda-customizer-controls-container').querySelector('.swiper-wrapper').querySelectorAll('.swiper-slide')
    const optionParentList = document.querySelectorAll('.swiper-selected-option-value-detail-container')
    optionParentList.forEach((item,index) => {
      nodelist[index].appendChild(item)
    })
    const arbtn = document.createElement('div')
    arbtn.style.display = 'flex';
    arbtn.style.alignItems = 'center';
    arbtn.style.justifyContent = 'center';
    arbtn.style.background = '#000';
    arbtn.style.color = '#fff';
    arbtn.style.borderRadius = '10px';
    arbtn.style.width = '100%';
    arbtn.style.height = '48px';
    arbtn.style.fontWeight = '400';
    arbtn.style.letterSpacing = '2px';
    arbtn.style.cursor = 'pointer';
    arbtn.style.marginTop = '28px';

    // 创建SVG图标
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '40');
    svg.setAttribute('height', '32');
    svg.setAttribute('viewBox', '0 0 40 32');
    svg.style.marginTop = '14px';
    svg.innerHTML = `
      <g><path d="M20.6082,0L2.08487,0C0.935187,0,0,0.957125,0,2.13362L0,13.3031C0,14.4796,0.948187,15.4375,2.11412,15.4375L7.17438,15.4375C8.03481,15.4375,8.80181,14.9175,9.13087,14.1091L10.6007,10.4301C10.7315,10.1083,11.0362,9.90112,11.3766,9.90112C11.7162,9.90112,12.0201,10.1091,12.1485,10.426L13.6216,14.1148C13.9433,14.9069,14.7192,15.4383,15.5504,15.4383L20.6091,15.4383C21.7896,15.4383,22.7508,14.4804,22.7508,13.3039L22.7508,2.13362C22.7492,0.957938,21.7888,0,20.6082,0ZM6.15306,9.72806C4.58494,9.72806,3.30931,8.45244,3.30931,6.88431C3.30931,5.31619,4.58494,4.04056,6.15306,4.04056C7.72119,4.04056,8.99681,5.31619,8.99681,6.88431C8.99681,8.45244,7.72119,9.72806,6.15306,9.72806ZM16.6977,9.72806C15.1296,9.72806,13.8539,8.45244,13.8539,6.88431C13.8539,5.31619,15.1296,4.04056,16.6977,4.04056C18.2658,4.04056,19.5414,5.31619,19.5414,6.88431C19.5414,8.45244,18.2658,9.72806,16.6977,9.72806Z" fill="#FFFFFF" fill-opacity="1" style="mix-blend-mode:passthrough"/></g>
    `;

    // 创建文字
    const text = document.createElement('span');
    text.textContent = 'AUGMENTED REALITY';

    // 组装
    arbtn.appendChild(svg);
    arbtn.appendChild(text);
    const parentContainer = document.querySelector('.tda-customizer-controls-container')
    parentContainer.appendChild(arbtn)

    if (arButton) {
      arButton.style.display = 'none';
      arbtn.addEventListener('click', (e) => {
        if (deviceType === 'iOS') {
          const title = document.querySelector('.product__title').innerText
          const map = {
            'beauty-salon-electrical-massage-backwash-basin-adjustable-chair-bella-v': 'https://cdn.shopify.com/3d/models/39d1ef97cc05472e/glbxz_com.usdz',
            'beauty-salon-stool-serene': 'https://cdn.shopify.com/3d/models/f300abf912e30300/beauty-salon-stool-serene.usdz',
            'beauty-salon-hairdressing-styling-chair-milano': 'https://cdn.shopify.com/3d/models/1ddcc9d4b0f24c0d/3dpea_com_1018-2.usdz'
          }
          if (title) {
            window.open(map[decodeURIComponent(title)], '_blank');
          } else {
            arButton.click()
          }
        } else {
          arButton.click()
        }
      });
      
    }
  }, 500);


}
function close3dView() {
  document.querySelector('.tda-customizer-wrapper').style.display = 'none';
  document.querySelector('.wcq_overlay').style.display = 'none';
  document.getElementById('shopify-section-template--25512662991226__174169878636fa7b13').style.zIndex = '0';
  if (window.innerWidth < 768) {
     let top = -parseInt(document.body.style.top);
      document.body.style.position = 'static';
      document.body.style.top = 0;
      window.scrollTo(0, top);
  }
}
